<template>
  <div v-if="student" class="container my-4">
    <h3 class="mb-4 text-center d-flex justify-content-center align-items-center">
      <i class="bi bi-person-fill me-2"></i> Student Code Information
    </h3>

    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <p>
          <i class="bi bi-file-person me-2"></i>
          <strong>First Name:</strong> {{ student.student?.first_name || 'N/A' }}
        </p>
      </div>
      <div class="col-12 col-md-6 mb-3">
        <p>
          <i class="bi bi-file-earmark-person me-2"></i>
          <strong>Last Name:</strong> {{ student.student?.last_name || 'N/A' }}
        </p>
      </div>
      <div class="col-12 col-md-6 mb-3">
        <p>
          <i class="bi bi-code-slash me-2"></i>
          <strong>Wave Code:</strong> {{ student.wave_code || 'N/A' }}
        </p>
      </div>
      <div class="col-12 col-md-6 mb-3">
        <p>
          <i class="bi bi-qr-code-scan me-2"></i>
          <strong>QR Code:</strong> {{ student.wave_qr_code || 'N/A' }}
        </p>
      </div>
      <div class="col-12 mb-3">
        <p>
          <i class="bi bi-check-circle me-2"></i>
          <strong>QR Status:</strong> {{ student.qr_status?.name || 'N/A' }}
        </p>
      </div>
    </div>

    <div class="showQR mb-4 text-center" v-if="student.wave_qr_code">
      <qrcode-vue :value="student.wave_qr_code" :size="200" />
    </div>

    <div class="downloadBtn">
      <button class="btn btn-primary" @click="downloadQRCode">
        <i class="bi bi-download"></i> Download QR Code
      </button>
    </div>
  </div>
</template>


<script>
import QrcodeVue from "qrcode.vue"; // Import the QR Code component

export default {
  props: {
    student: {
      type: [Object, null], // Accepts both Object and null
      required: true,
    },
  },
  components: {
    QrcodeVue, // Register the component
  },
  methods: {
    downloadQRCode() {
      const canvas = document.querySelector("canvas"); // Select the canvas element
      if (!canvas) {
        alert("QR Code not available for download.");
        return;
      }
      const dataUrl = canvas.toDataURL("image/png"); // Convert canvas to data URL
      const link = document.createElement("a"); // Create a link element
      link.href = dataUrl; // Set link href to data URL
      link.download = "QRCode.png"; // Set the download file name
      link.click(); // Trigger download
    },
  },
};
</script>

<style scoped>
h3 {
  text-align: center;
}
.showQR {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn {
  display: flex;
  align-items: center;
  gap: 5px;
}

.downloadBtn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

